/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filterpresetcool2Inputs */

const en_filterpresetcool2 = /** @type {(inputs: Filterpresetcool2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cool`)
};

const de_filterpresetcool2 = /** @type {(inputs: Filterpresetcool2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kühl`)
};

/**
* | output |
* | --- |
* | "Cool" |
*
* @param {Filterpresetcool2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const filterpresetcool2 = /** @type {((inputs?: Filterpresetcool2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filterpresetcool2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filterpresetcool2(inputs)
	return de_filterpresetcool2(inputs)
});
export { filterpresetcool2 as "filterPresetCool" }